import * as React from "react";
import C from "classnames";
const sizeMapper = {
    sm: "input-group-sm",
    lg: "input-group-lg",
};
export const InputGroup = ({ children, className, merge, testId, size, }) => {
    return (React.createElement("div", { className: C("input-group", merge && "input-group-merge", className && className, size && sizeMapper[size]), "data-testid": testId }, children));
};
//# sourceMappingURL=InputGroup.js.map